<template>
  <Base icon="mdi-school" :satisfied="requirement.satisfied" tooltip>
    <span>
      {{ description }}
    </span>
    <span slot="tooltip">
      {{ first ? 'The ideal candidate' : 'and' }}
      {{ requirement.mandatory ? 'must' : 'could' }} have
      {{ requirement.negative ? 'less than' : 'at least' }} a {{ description }} or
      equivalent qualification
    </span>
  </Base>
</template>

<script>
// Component
import Base from '@/components/guest/opportunities/requirements/Base'

// Vue Component
export default {
  components: { Base },
  props: {
    requirement: { type: Object, required: true },
    first: { type: Boolean },
  },
  computed: {
    description() {
      switch (this.requirement.country.code) {
        case 'ZA':
          switch (this.requirement.requiredLevel) {
            case 5:
              return 'Higher Certificate'
            case 6:
              return 'Diploma'
            case 7:
              return "Bachelor's Degree"
            case 8:
              return 'Honours Degree'
            case 9:
              return "Master's Degree"
            case 10:
              return 'Doctoral Degree'
            default:
              return `NQF ${this.requirement.requiredLevel}`
          }
      }
      return `Level ${this.requirement.requiredLevel} in ${this.requirement.country.code}`
    },
  },
}
</script>
